<template>
    <div id="web-newsInfo">
        <div class="wrapper">
            <!-- PC端 -->
            <div class="L-container-fluid  d-none d-md-block">
                <div class="wrapper">
                    <div class="row">
                        <div class="col-12 col-md-12 col-xl-12 text-center">
                            <div class="web-item">
                                <div class="title">
                                    {{currenObj.title}}
                                </div>
                                <div class="time">
                                    发表日期：{{currenObj.publishDate}}
                                </div>
                                <div class="NewsInfo-content-web">
                                    <div class="center">
                                        <div v-html="currenObj.content"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom-btn">
                                <div class="btn left-page" v-if="pre" @click="linktoNewsListInfoNext(pre)">
                                    <div class="nowrap_ellipsis">
                                        <span>上一篇:</span>
                                        <span>{{pre.title}}</span>
                                    </div>
                                </div>
                                <div class="btn center-page" @click="linkNewsList">
                                    返回列表
                                </div>
                                <div class="btn rigth-page" v-if="next" @click="linktoNewsListInfoNext(next)">
                                    <div class="nowrap_ellipsis">
                                        <span>下一篇:</span>
                                        <span>{{next.title}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-md-none">
                <div class="phone">
                    <!-- 新闻列表页面移动端 -->
                    <div class="phone-item">
                        <div class="title">{{currenObj.title}}</div>
                        <div class="time"> 发表日期：{{currenObj.publishDate}}</div>
                        <div class="NewsInfo-content">
                            <div v-html="currenObj.content"></div>
                        </div>
                        <div class="bottom-btn">
                            <div class="btn left-page" v-if="pre" @click="linktoNewsListInfoNext(pre)">
                                <div class="nowrap_ellipsis">
                                    <span>上一篇:</span>
                                    <span>{{pre.title}}</span>
                                </div>
                            </div>
                            <div class="btn rigth-page" v-if="next" @click="linktoNewsListInfoNext(next)">
                                <div class="nowrap_ellipsis">
                                    <span>下一篇:</span>
                                    <span>{{next.title}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
    import axios from 'axios';
    // 获取设备类型（简单示例，实际上最好使用CSS媒体查询辅助判断）
    function getDeviceType() {
        const width = window.innerWidth || document.documentElement.clientWidth;
        if (width > 768) {
            return 'desktop';
        } else {
            return 'mobile';
        }
    }
    export default {
        name: "NewsInfo",
        props: ['id'],
        components: {
        },
        metaInfo() {
            return {
                title: `${this.currenObj.title}—广州光晨信息科技有限公司`,
                meta: [
                    { name: "keywords", content: "光晨科技,广州光晨科技,广州光晨信息科技有限公司" },
                    { name: "description", content: "光晨科技成立于2015年，凭借大数据输出的战略洞察、创造力、行动力等生产实效的核心竞争力，为客户提供全域数字内容营销。" },
                ],
            };
        },
        data() {
            return {
                currenObjId: "",
                currenObj: {},//当前数据
                pre: {},//上一篇数据
                next: null
            };
        },
        created() {
            this.deviceType = getDeviceType();
            this.currenObjId = this.$route.params.id
            this.getNewsList(this.currenObjId)
        },
        destroyed() {
        },
        watch: {
            '$route.params.id'(newId, oldId) {
                if (newId) {
                    this.currenObjId = newId || null
                    if (this.currenObjId) {
                        this.getNewsList(this.currenObjId)
                        window.scrollTo(0, 0)
                    }
                }


            }
        },

        async mounted() {
            window.scrollTo(0, 0)

        },
        methods: {
            async getNewsList(id) {
                let params = {
                    id
                }
                const news = await axios.get('https://www.glotech.com.cn/api/v1/news/getContextDTO', { params }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                let newsList = news.data

                this.currenObj = newsList.current
                //清除所有html空格
                let txt = this.currenObj.content
                txt = txt.replace(/&nbsp;/ig, "");

                //清除所有空行（摘录网上，实测可用）
                var arrPattern = [
                    '<p(>|\\s+[^>]*>)(&nbsp|&nbsp;|\\s|　|<br\\s*(\/)?>)*<\/p(>|\\s+[^>]*>)',
                    '(<br\\s*(\/)?>((\\s|&nbsp;|&nbsp|　)*)){2,}',
                    '(<p(>|\\s+[^>]*>))((&nbsp|&nbsp;|\\s)*<br\\s*(\/)?>)*((.|\n|\r)*?<\/p(>|\\s+[^>]*>))'
                ]
                var arrReplace = ['', '<br />$3', '$1$6'];
                for (var i = 0; i < arrPattern.length; i++) {
                    var arrRegExp = new RegExp(arrPattern[i], 'img')
                    txt = txt.replace(arrRegExp, arrReplace[i])
                }

                //清除所有非空格的空白字符，空格字符去除可能导致元素属性出错
                txt = txt.replace(/[\f\n\r\t\v]/ig, "")

                //清除所有span
                txt = txt.replace(/<(\/span|span).*?>/ig, "")

                //清除超链接，将网址分离在后
                txt = txt.replace(/<a.*?href\s*=\s*[\"|\'](.*?)[\"|\'].*?>(.*?)<\/a>/ig, "$2[网址：$1]")
                //实际运行中发现有些错误的a链接可能根本没有href，所以需要再次清理
                txt = txt.replace(/<(\/a|a).*?>/ig, "")

                //清除所有class，为防止有些class不加引号，因此强制规定只清除元素内的class，这种写法最笨和直观，聪明的看下一个
                txt = txt.replace(/<([a-zA-Z1-6]+)(.*?)\s*class\s*=\s*[\"|\']?.*?[\"|\']\s*(.*?)>?/ig, "<$1 $2 $3>")

                //清除所有style属性
                //直接量语法：
                txt = txt.replace(/style\s*?=\s*?([\'\"])[\s\S]*?\1/ig, "")
                //RegExp对象语法，可用于自定义变量，比如出了style以外的class，lang等等
                var v = "style"
                txt = txt.replace(new RegExp(v + "\\s*?=\\s*?([\'\"])[\\s\\S]*?\\1", "ig"), "")

                //清除所有元素属性，超链接可能被清除
                txt = txt.replace(/<([a-zA-Z1-6]+)(\s*[^>]*)?>/ig, "<$1>")

                //给每段加上样式
                txt = txt.replace(/<p.*?>/ig, "<p style=\"font-size:16px;font-family:仿宋;line-height:36px;text-indent:2em;\">")

                //去除除img标签外其它标签
                // txt = txt.replace(/<(?!img).*?>/g, "")
                // //如果保留img,p标签，则为：
                // txt = txt.replace(/<(?!img|p|/p).*?> /g, "")
                console.log(this.currenObj.content, '----')
                this.pre = newsList.pre
                this.next = newsList.next
            },
            // 跳转详情
            linktoNewsListInfoNext(item) {
                // 存取按进去的新闻信息id
                localStorage.setItem("currenObjId", JSON.stringify(item.id))
                // 判断要跳转的路由是否与当前路由相同
                if (this.id !== item.id.toString()) {
                    // 如果不相同，则执行跳转操作
                    this.$router.push({
                        name: "NewsInfo",
                        params: { id: item.id },
                    })
                }
            },
            // 跳转列表页面
            linkNewsList() {
                this.$router.push({ name: "NewsList" });
            }

        },
    }
</script>